import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { RegistrationSteps } from "../Registration";
import StepContainer from "./StepContainer";
import GradientButton from "../../Core/GradientButton";

export default function Welcome(props) {
	const [consentPOPIA, setPOPIAConsent] = useState(false);
	const [showingConsentError, showConsentError] = useState(false);

	function handleContinueClicked() {
		if (!consentPOPIA) {
			showConsentError(true);
			return;
		}
		showConsentError(false);
		props.onContinue(null, RegistrationSteps.Welcome.Step);
	}

	return (
		<StepContainer title="Welcome to Zing Fibre!">
			<Row className="mb-4">
				<Col>
					<p>Please go through the following questions to sign up for your account and enable internet services within your home.</p>
					<h5 className="mt-3">Disclaimer:</h5>
					<p className="mt-1">
						Zing Fibre will provide the customer with a free to use Customer Premises Equipment (CPE) which remains the property of Zing Fibre into perpetuity. Zing Fibre retains the right to repossess the CPE at any point where it deems the customer is not making full use of the CPE. Following a period of 3 months without any activity in the customer's account, Zing Fibre will consider that the client is no longer making full use of the free to use CPE and will act on its right to repossess the CPE. Zing Fibre retains the right to hold the customer liable should the CPE be damaged, sold, transferred or otherwise disposed of.
					</p>
				</Col>
			</Row>
			<Row className="mb-4">
				<Col className="d-flex justify-content-center">
					<div className="form-check">
						<input
							checked={consentPOPIA}
							onChange={(e) => setPOPIAConsent(e.target.checked)}
							type="checkbox"
							className="form-check-input"
							id="popiaConsent"
						/>
						<label htmlFor="popiaConsent" className="form-check-label">
							I consent to the collection of my information in accordance with the POPIA act.
						</label>
					</div>
					{showingConsentError && (
						<div className="text-center mt-2">
							<small className="text-danger">Consent to collect information is required</small>
						</div>
					)}
				</Col>
			</Row>
			<Row className="text-center">
				<Col xs={12} md={6} lg={6} xl={4} className="offset-xs-0 offset-md-3 offset-xl-4">
					<GradientButton title="Continue" variant="greenYellow" onClick={handleContinueClicked} />
				</Col>
			</Row>
		</StepContainer>
	);
}
